import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {DataService} from '../../services/data.service';
import {AclUser} from '../../interfaces/app-user';
import {BehaviorSubject, Observable} from 'rxjs';
import {ReactiveFormsModule, UntypedFormControl} from '@angular/forms';
import {map, startWith} from 'rxjs/operators';
import {MatFormField, MatInput} from '@angular/material/input';
import {MatAutocomplete, MatAutocompleteTrigger, MatOption} from '@angular/material/autocomplete';
import {AsyncPipe} from '@angular/common';



@Component({
    selector: 'app-user-picker',
    template: `
        <mat-form-field class="f-medium" [appearance]="appearance">
            <input type="text" [placeholder]="placeholder" aria-label="Number" matInput [formControl]="myControl"
                   [matAutocomplete]="auto" [readonly]="readonly" [required]="required">
            <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn.bind(this)">
                @for (option of filteredOptions | async; track option) {
                    <mat-option [value]="option">
                        {{ option.email }}
                    </mat-option>
                }
            </mat-autocomplete>
        </mat-form-field>`,
    imports: [
        MatFormField,
        MatAutocomplete,
        MatOption,
        ReactiveFormsModule,
        MatInput,
        MatAutocompleteTrigger,
        AsyncPipe
    ],
    standalone: true,
    styleUrls: ['./user-picker.component.scss']
})
export class UserPickerComponent implements OnInit {

    // @Input() user: AclUser;
    @Input() placeholder: string;
    @Input() myControl: UntypedFormControl;
    @Input() readonly = false;
    @Input() required = false;
    @Input() appearance: 'fill' | 'outline' = 'fill';
    @Output() userSelected = new EventEmitter();

    private _displayWithEmail = false;
    @Input() set displayWithEmail(v: boolean) {
        this._displayWithEmail = v;
    }

    // public myControl: FormControl = new FormControl();
    public filteredOptions: Observable<AclUser[]>;

    private userCache = new BehaviorSubject<AclUser[]>([]);

    constructor(private dataService: DataService) {
    }

    ngOnInit() {
        this.myControl.setValidators([this.userExistsValidator]);
        this.dataService.getActiveAppUsers()
            .subscribe(this.userCache);

        this.filteredOptions = this.myControl.valueChanges
            .pipe(
                startWith({} as AclUser),
                map(user => user && typeof user === 'object' ? user.email : String(user)),
                map(email => email ? this.filter(email) : this.userCache.value.slice())
            );
    }

    displayFn(user: AclUser): string {
        if (user) {
            return (user.displayName && !this._displayWithEmail) ? user.displayName : user.email ? user.email : user.id;
        } else {
            return null;
        }
    }

    private userExistsValidator = (control): Record<string, any> => {
        if (!control.value) {
            return {'userNotDefined': {value: control.value}};
        }
        return (typeof control.value === 'object') ? null : {'userNotExists': {value: control.value}};
    }

    private filter(val: string): AclUser[] {
        return this.userCache.value
            .filter(option => {
                if (option.email) {
                    return option.email.toLowerCase().indexOf(val.toLowerCase()) === 0;
                } else {
                    return option.id.toLowerCase().indexOf(val.toLowerCase()) === 0;
                }
            });
    }

}
